export default {
	namespaced: true,
	state: {
		TOKEN: localStorage.getItem("TOKEN") || "",
		USER_INFO: localStorage.getItem("USER_INFO") || {},
		STOP_REQUEST: false
	},
	mutations: {
		['TOKEN'](state, data) {
			localStorage.setItem("TOKEN", data);
			state.TOKEN = data;
		},
		['USER_INFO'](state, data) {
			localStorage.setItem("USER_INFO", data);
			state.USER_INFO = data;
		},
		['STOP_REQUEST'](state, data) {
			state.STOP_REQUEST = data;
		}
	}
}